export const STATUS_CONFIG = {
  Pending: { color: "#f59e0b", light: "#fef3c7" },
  "Correction Requested": { color: "#ef4444", light: "#fee2e2" },
  Reviewed: { color: "#3b82f6", light: "#dbeafe" },
  Approved: { color: "#10b981", light: "#d1fae5" }
};

export const STATUS_OPTIONS = [
  "Pending",
  "Correction Requested",
  "Reviewed",
  "Approved"
];

export function StatusBadge({ status }) {
  const c = STATUS_CONFIG[status];
  return (
    <span
      style={{
        background: c.light,
        color: c.color,
        padding: "3px 10px",
        borderRadius: "15px",
        fontSize: "12px",
        fontWeight: 600
      }}
    >
      {status}
    </span>
  );
}